import DataTabs from 'packages/data/tabs';
import DataCardText from 'packages/data/cardText';
import DataBox from 'packages/data/box';
import DataProgress from 'packages/data/progress';
import DataIcons from 'packages/data/icons';
import DataCard from 'packages/data/card';
import DataDisplay from 'packages/data/display';
import DataImgText from 'packages/data/imgText';
import DataOperaText from 'packages/data/operaText';
import DataRotate from 'packages/data/rotate';
import DataPay from 'packages/data/pay';
import DataPrice from 'packages/data/price';
import DataPanel from 'packages/data/panel';
import DataStatistic from 'packages/data/statistic';
import DataWeather from 'packages/data/weather';
import DataRank from 'packages/data/rank';
import DataProfile from 'packages/data/profile';
import DataProduct from 'packages/data/product';
import DataCountdown from 'packages/data/countdown';
import DataNotice from 'packages/data/notice';
import DataTask from 'packages/data/task';
import DataList from 'packages/data/list';
import DataDashboard from 'packages/data/dashboard';
export default { DataTabs, DataCardText, DataBox, DataProgress, DataIcons, DataCard, DataDisplay, DataImgText, DataOperaText, DataRotate, DataPay, DataPrice, DataPanel, DataStatistic, DataWeather, DataRank, DataProfile, DataProduct, DataCountdown, DataNotice, DataTask, DataList, DataDashboard };


